export default {
  debug: process.env.VUE_APP_SOCKET_DEBUG || false,
  connectionUrl: process.env.VUE_APP_SOCKET_URL,
  socket: null,
  readyState: WebSocket.CLOSED,
  credentials: null,
  reconnection: false,
  reconnectionTimeoutId: 0,
  isConnected: false,
  message: null,
  messageUpdateSuspended: false,
  newMessageAvailable: false,
};
